import { render } from "./artemisadsIcon.vue?vue&type=template&id=45669575"
import script from "./artemisadsIcon.vue?vue&type=script&lang=js"
export * from "./artemisadsIcon.vue?vue&type=script&lang=js"

import "./artemisadsIcon.vue?vue&type=style&index=0&id=45669575&lang=css"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__